import React from 'react'

function Footer() {
    return (
        <div className="container-fluid bg-dark text-white-50 footer pt-5">
            <div className="container py-5">
                <div className="row g-5">
                    {/* About / Branding */}
                    <div className="col-md-6 col-lg-4 wow fadeIn" data-wow-delay="0.1s">
                        <a href="/index" className="d-inline-block mb-3">
                            <h1 className="text-white">Bluevipers Technology</h1>
                        </a>
                        <p className="mb-0">
                            Bluevipers Technology delivers cutting-edge solutions in web development, mobile apps, software, and digital marketing to help businesses thrive in the digital era.
                        </p>
                    </div>

                    {/* Contact */}
                    <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.3s">
                        <h5 className="text-white mb-4">Get In Touch</h5>
                        <p><i className="fa fa-map-marker-alt me-3" />Gulvanchi, Jath, MH - 416 403.</p>
                        <p><i className="fa fa-phone-alt me-3" />+91 84594 32930</p>
                        <p><i className="fa fa-envelope me-3" />blueviperstechnology@gmail.com</p>
                        <div className="d-flex pt-2">
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-twitter" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-facebook-f" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-youtube" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-instagram" /></a>
                            <a className="btn btn-outline-light btn-social" href="#"><i className="fab fa-linkedin-in" /></a>
                        </div>
                    </div>

                    {/* Quick Links / Menu */}
                    <div className="col-md-6 col-lg-2 wow fadeIn" data-wow-delay="0.5s">
                        <h5 className="text-white mb-4">Quick Links</h5>
                        <a className="btn btn-link text-white-50" href="/index">Home</a>
                        <a className="btn btn-link text-white-50" href="/about">About</a>
                        <a className="btn btn-link text-white-50" href="/our-team">Our Team</a>
                        <a className="btn btn-link text-white-50" href="/career">Career</a>
                        <a className="btn btn-link text-white-50" href="/contact">Contact</a>


                    </div>

                    {/* Portfolio / Career / Contact */}
                    <div className="col-md-6 col-lg-3 wow fadeIn" data-wow-delay="0.7s">
                        <h5 className="text-white mb-4">Visiting Counter</h5>
                        <a href="#" ><img src="https://counter1.optistats.ovh/private/freecounterstat.php?c=gntz1qgquu9hp5b85annty6xwmjynr6n" border={0} /></a>
                    </div>
                </div>
            </div>

            {/* Copyright */}
            <div className="container wow fadeIn" data-wow-delay="0.1s">
                <div className="copyright">
                    <div className="row">
                        <div className="col-md-6 text-center text-md-start mb-3 mb-md-0">
                            © <a className="border-bottom" href="#">Bluevipers Technology</a>, All Rights Reserved.
                        </div>
                        <div className="col-md-6 text-center text-md-end">
                            <div className="footer-menu">
                                <a href="#">Privacy Policy</a>
                                <a href="#">Refund Policy</a>
                                <a href="#">Terms & Conditions</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Footer
